
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Privacy = () => {
  return <div className="min-h-screen bg-background">
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <Link to="/">
            <Button variant="ghost" className="mb-6">← Back to Home</Button>
          </Link>
          
          <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
          
          <div className="space-y-6 text-film-600">
            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Overview</h2>
              <p>This privacy policy outlines how Safelight collects, uses, and protects your information when you use our airport film photography review platform.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Information We Collect</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Profile information (username, avatar)</li>
                <li>Review content and ratings</li>
                <li>Airport preferences and experiences</li>
                <li>Social media links (optional)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">How We Use Your Information</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>To display your reviews and ratings to other users</li>
                <li>To improve our airport review database</li>
                <li>To communicate important updates about the platform</li>
                <li>To maintain and improve the quality of our service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Data Storage</h2>
              <p>Your data is securely stored using Supabase's infrastructure. We implement appropriate security measures to protect your information from unauthorized access, alteration, or disclosure.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Your Rights</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal data</li>
                <li>Request correction of your personal data</li>
                <li>Delete your account and associated data</li>
                <li>Export your review history</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Contact Us</h2>
              <p>If you have any questions about this privacy policy or your personal data, please contact us at through the feedback tab in settings.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Updates to This Policy</h2>
              <p>We may update this privacy policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
              <p className="mt-2 text-sm">Last updated: February 2025</p>
            </section>
          </div>
        </div>
      </main>
    </div>;
};
export default Privacy;
